












import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

const ScrollIndicatorProps = Vue.extend({
  props: {
    totalItems: Number,
    activeIndex: Number,
    videoProgress: String,
  },
});

@Component
export default class ScrollIndicator extends (ScrollIndicatorProps) {
  reset = false;

  itemClass (index: number) {
    return {
      'brandhub-scroll-indicator__item--active': index === this.activeIndex + 1,
      'brandhub-scroll-indicator__item--video-progress': index === this.activeIndex + 1 && this.videoProgress,
      'brandhub-scroll-indicator__item--reset': this.reset,
    };
  }

  get itemsStyle () {
    return `--stage-video-progress: ${this.videoProgress}%`;
  }

  @Watch('videoProgress')
  handleVideoProgressUpdate (newValue: string, oldValue: string) {
    this.reset = parseFloat(newValue) < parseFloat(oldValue);
  }
}
